
// @ts-nocheck


export const localeCodes =  [
  "tw",
  "en",
  "fr",
  "ms",
  "de",
  "it",
  "es",
  "jp",
  "kr",
  "th",
  "br",
  "id",
  "vn",
  "ru",
  "tr",
  "sa"
]

export const localeLoaders = {
  "tw": [{ key: "../../../locales/zh_TW.json", load: () => import("../../../locales/zh_TW.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_zh_TW_json" */), cache: true }],
  "en": [{ key: "../../../locales/en_US.json", load: () => import("../../../locales/en_US.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_en_US_json" */), cache: true }],
  "fr": [{ key: "../../../locales/fr_FR.json", load: () => import("../../../locales/fr_FR.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_fr_FR_json" */), cache: true }],
  "ms": [{ key: "../../../locales/ms_MY.json", load: () => import("../../../locales/ms_MY.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_ms_MY_json" */), cache: true }],
  "de": [{ key: "../../../locales/de_DE.json", load: () => import("../../../locales/de_DE.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_de_DE_json" */), cache: true }],
  "it": [{ key: "../../../locales/it_IT.json", load: () => import("../../../locales/it_IT.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_it_IT_json" */), cache: true }],
  "es": [{ key: "../../../locales/es_ES.json", load: () => import("../../../locales/es_ES.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_es_ES_json" */), cache: true }],
  "jp": [{ key: "../../../locales/ja_JP.json", load: () => import("../../../locales/ja_JP.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_ja_JP_json" */), cache: true }],
  "kr": [{ key: "../../../locales/ko_KR.json", load: () => import("../../../locales/ko_KR.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_ko_KR_json" */), cache: true }],
  "th": [{ key: "../../../locales/th_TH.json", load: () => import("../../../locales/th_TH.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_th_TH_json" */), cache: true }],
  "br": [{ key: "../../../locales/pt_PT.json", load: () => import("../../../locales/pt_PT.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_pt_PT_json" */), cache: true }],
  "id": [{ key: "../../../locales/id_ID.json", load: () => import("../../../locales/id_ID.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_id_ID_json" */), cache: true }],
  "vn": [{ key: "../../../locales/vi_VN.json", load: () => import("../../../locales/vi_VN.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_vi_VN_json" */), cache: true }],
  "ru": [{ key: "../../../locales/ru_RU.json", load: () => import("../../../locales/ru_RU.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_ru_RU_json" */), cache: true }],
  "tr": [{ key: "../../../locales/tr_TR.json", load: () => import("../../../locales/tr_TR.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_tr_TR_json" */), cache: true }],
  "sa": [{ key: "../../../locales/ar_IL.json", load: () => import("../../../locales/ar_IL.json" /* webpackChunkName: "locale__root_workspace_ldshop_vest_locales_ar_IL_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "tw",
      "qiYuCode": "zh-tw",
      "iso": "zh-tw",
      "name": "繁體中文",
      "files": [
        "../../locales/zh_TW.json"
      ]
    },
    {
      "code": "en",
      "qiYuCode": "en",
      "iso": "x-default",
      "name": "English",
      "files": [
        "../../locales/en_US.json"
      ]
    },
    {
      "code": "fr",
      "qiYuCode": "fr",
      "iso": "fr",
      "name": "Français",
      "files": [
        "../../locales/fr_FR.json"
      ]
    },
    {
      "code": "ms",
      "qiYuCode": "en",
      "iso": "ms",
      "name": "Bahasa Melayu",
      "files": [
        "../../locales/ms_MY.json"
      ]
    },
    {
      "code": "de",
      "qiYuCode": "de",
      "iso": "de",
      "name": "Deutsch",
      "files": [
        "../../locales/de_DE.json"
      ]
    },
    {
      "code": "it",
      "qiYuCode": "en",
      "iso": "it",
      "name": "Italiano",
      "files": [
        "../../locales/it_IT.json"
      ]
    },
    {
      "code": "es",
      "qiYuCode": "es",
      "iso": "es",
      "name": "Español",
      "files": [
        "../../locales/es_ES.json"
      ]
    },
    {
      "code": "jp",
      "qiYuCode": "ja",
      "iso": "ja",
      "name": "日本語",
      "files": [
        "../../locales/ja_JP.json"
      ]
    },
    {
      "code": "kr",
      "qiYuCode": "ko",
      "iso": "ko",
      "name": "한국어",
      "files": [
        "../../locales/ko_KR.json"
      ]
    },
    {
      "code": "th",
      "qiYuCode": "th",
      "iso": "th",
      "name": "ภาษาไทย",
      "files": [
        "../../locales/th_TH.json"
      ]
    },
    {
      "code": "br",
      "qiYuCode": "pt",
      "iso": "pt-br",
      "name": "Português",
      "files": [
        "../../locales/pt_PT.json"
      ]
    },
    {
      "code": "id",
      "qiYuCode": "id",
      "iso": "id",
      "name": "Bahasa Indonesia",
      "files": [
        "../../locales/id_ID.json"
      ]
    },
    {
      "code": "vn",
      "qiYuCode": "vi",
      "iso": "vi",
      "name": "Tiếng Việt",
      "files": [
        "../../locales/vi_VN.json"
      ]
    },
    {
      "code": "ru",
      "qiYuCode": "ru",
      "iso": "ru",
      "name": "Pусский",
      "files": [
        "../../locales/ru_RU.json"
      ]
    },
    {
      "code": "tr",
      "qiYuCode": "en",
      "iso": "tr",
      "name": "Türkçe",
      "files": [
        "../../locales/tr_TR.json"
      ]
    },
    {
      "code": "sa",
      "qiYuCode": "en",
      "iso": "sa",
      "name": "العربية",
      "files": [
        "../../locales/ar_IL.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "../../locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://www.ldshop.gg",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "tw",
    "qiYuCode": "zh-tw",
    "iso": "zh-tw",
    "name": "繁體中文",
    "files": [
      {
        "path": "../../locales/zh_TW.json"
      }
    ]
  },
  {
    "code": "en",
    "qiYuCode": "en",
    "iso": "x-default",
    "name": "English",
    "files": [
      {
        "path": "../../locales/en_US.json"
      }
    ]
  },
  {
    "code": "fr",
    "qiYuCode": "fr",
    "iso": "fr",
    "name": "Français",
    "files": [
      {
        "path": "../../locales/fr_FR.json"
      }
    ]
  },
  {
    "code": "ms",
    "qiYuCode": "en",
    "iso": "ms",
    "name": "Bahasa Melayu",
    "files": [
      {
        "path": "../../locales/ms_MY.json"
      }
    ]
  },
  {
    "code": "de",
    "qiYuCode": "de",
    "iso": "de",
    "name": "Deutsch",
    "files": [
      {
        "path": "../../locales/de_DE.json"
      }
    ]
  },
  {
    "code": "it",
    "qiYuCode": "en",
    "iso": "it",
    "name": "Italiano",
    "files": [
      {
        "path": "../../locales/it_IT.json"
      }
    ]
  },
  {
    "code": "es",
    "qiYuCode": "es",
    "iso": "es",
    "name": "Español",
    "files": [
      {
        "path": "../../locales/es_ES.json"
      }
    ]
  },
  {
    "code": "jp",
    "qiYuCode": "ja",
    "iso": "ja",
    "name": "日本語",
    "files": [
      {
        "path": "../../locales/ja_JP.json"
      }
    ]
  },
  {
    "code": "kr",
    "qiYuCode": "ko",
    "iso": "ko",
    "name": "한국어",
    "files": [
      {
        "path": "../../locales/ko_KR.json"
      }
    ]
  },
  {
    "code": "th",
    "qiYuCode": "th",
    "iso": "th",
    "name": "ภาษาไทย",
    "files": [
      {
        "path": "../../locales/th_TH.json"
      }
    ]
  },
  {
    "code": "br",
    "qiYuCode": "pt",
    "iso": "pt-br",
    "name": "Português",
    "files": [
      {
        "path": "../../locales/pt_PT.json"
      }
    ]
  },
  {
    "code": "id",
    "qiYuCode": "id",
    "iso": "id",
    "name": "Bahasa Indonesia",
    "files": [
      {
        "path": "../../locales/id_ID.json"
      }
    ]
  },
  {
    "code": "vn",
    "qiYuCode": "vi",
    "iso": "vi",
    "name": "Tiếng Việt",
    "files": [
      {
        "path": "../../locales/vi_VN.json"
      }
    ]
  },
  {
    "code": "ru",
    "qiYuCode": "ru",
    "iso": "ru",
    "name": "Pусский",
    "files": [
      {
        "path": "../../locales/ru_RU.json"
      }
    ]
  },
  {
    "code": "tr",
    "qiYuCode": "en",
    "iso": "tr",
    "name": "Türkçe",
    "files": [
      {
        "path": "../../locales/tr_TR.json"
      }
    ]
  },
  {
    "code": "sa",
    "qiYuCode": "en",
    "iso": "sa",
    "name": "العربية",
    "files": [
      {
        "path": "../../locales/ar_IL.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
